var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0L0 6.54545V16.3636C0 25.4455 6.4 33.9382 15 36C23.6 33.9382 30 25.4455 30 16.3636V6.54545L15 0ZM15 9.81818C17.3333 9.81818 19.6667 11.6182 19.6667 13.9091V16.3636C20.6667 16.3636 21.6667 17.3455 21.6667 18.4909V24.2182C21.6667 25.2 20.6667 26.1818 19.5 26.1818H10.3333C9.33333 26.1818 8.33333 25.2 8.33333 24.0545V18.3273C8.33333 17.3455 9.33333 16.3636 10.3333 16.3636V13.9091C10.3333 11.6182 12.6667 9.81818 15 9.81818ZM15 11.7818C13.6667 11.7818 12.5 12.6 12.5 13.9091V16.3636H17.5V13.9091C17.5 12.6 16.3333 11.7818 15 11.7818Z",
    fill: "#E38024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyicon);
export default __webpack_public_path__ + "static/media/Privacy icon.ccb3dfa528b24a8ae7ba8841a0412933.svg";
export { ForwardRef as ReactComponent };